import React, { Component } from 'react';
import Dfp from './Dfp';

class Splash extends Component {
    constructor(){
        super();
        this.state = {
            showClose: false
        }
    }

    renderAdsEnd(evnt,adunit){
        window.splashAd = adunit;

        if(!evnt.isEmpty){
            if(evnt.slot==adunit){
                document.getElementById('ad_splash-frame').style.display = "block";
                document.getElementById('ad_splash-close-wrapper').onclick = null;
                document.getElementById('ad_splash-close-wrapper').onclick = function(){
                    document.getElementById('ad_splash-frame').style.display = "none";
                    googletag.pubads().clear([window.splashAd]);
                }
            }
        }
    }

    render(){
        const { theme } = this.props
        const { showClose } = this.state

        setTimeout(() => {
            this.setState({
                showClose: true
            })
        }, 3000)

        return (
            <div id="ad_splash-frame">
                <div id="ad_splash-box">
                    <div id="ad_splash">
                        <Dfp
                            adUnit={ theme + '_splashad_mobile_320x460' }
                            sizes={[[320,460]]}
                            callback={this.renderAdsEnd}
                        />
                    </div>
                    <div id="ad_splash-close-wrapper">
                        {
                            showClose ? <div id="ad_splash-close">
                                <div id="ad_splash-btn"></div>
                            </div> : ''
                        }

                        {/*<div id="ad_splash-close">*/}
                        {/*<div id="ad_splash-btn"></div>*/}
                        {/*</div>*/}
                    </div>
                </div>
            </div>
        )
    }
}

export default Splash


// WEBPACK FOOTER //
// ./src/Splash.js